/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Tip } from './Tip';
import {
    TipFromJSON,
    TipFromJSONTyped,
    TipToJSON,
} from './Tip';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface GetTipsResponse
 */
export interface GetTipsResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTipsResponse
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof GetTipsResponse
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof GetTipsResponse
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof GetTipsResponse
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof GetTipsResponse
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof GetTipsResponse
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof GetTipsResponse
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<Tip>}
     * @memberof GetTipsResponse
     */
    data?: Array<Tip>;
}

/**
 * Check if a given object implements the GetTipsResponse interface.
 */
export function instanceOfGetTipsResponse(value: object): value is GetTipsResponse {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function GetTipsResponseFromJSON(json: any): GetTipsResponse {
    return GetTipsResponseFromJSONTyped(json, false);
}

export function GetTipsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTipsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TipFromJSON)),
    };
}

export function GetTipsResponseToJSON(value?: GetTipsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TipToJSON)),
    };
}

